import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { GeoReadinessPage } from "@/components/geo/GeoReadinessPage";
import {
  breadcrumbJsonLd,
  buildHead,
  faqJsonLd,
  serviceJsonLd,
  webPageJsonLd,
} from "@/lib/seo";
import { alternatePath } from "@/lib/i18n";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import { GEO_READINESS_FAQS } from "@/lib/geo-readiness-faqs";

const PATH = "/es/auditoria-geo";
const TITLE = "Auditoría GEO: Evidencia de Visibilidad en IA y Roadmap · Shugert";
const DESCRIPTION =
  "Evalúa acceso técnico, evidencia de entidad, superficies citables, claridad de contenido, datos estructurados y preparación competitiva. Recibe un roadmap GEO documentado de 90 días sin garantías de citación.";
const MODIFIED = "2026-08-19T00:00:00.000Z";

export const Route = createFileRoute("/es/auditoria-geo")({
  loader: async () => {
    await setEdgeHtmlCache();
  },
  head: () =>
    buildHead({
      locale: "es",
      title: TITLE,
      description: DESCRIPTION,
      path: PATH,
      altPath: alternatePath(PATH, "en"),
      jsonLd: [
        webPageJsonLd({
          name: "Auditoría GEO: Evidencia de Visibilidad en IA y Roadmap",
          path: PATH,
          description: DESCRIPTION,
          inLanguage: "es-MX",
          dateModified: MODIFIED,
        }),
        serviceJsonLd({
          name: "Auditoría GEO Readiness",
          description:
            "Diagnóstico estructurado de visibilidad en IA que revisa acceso técnico, evidencia de entidad, superficies citables, claridad de contenido, datos estructurados y preparación competitiva, con un roadmap priorizado de 90 días.",
          path: PATH,
          serviceType: "Auditoría GEO y de visibilidad en IA",
          locale: "es",
          deliverables: [
            "Evaluación GEO en seis dimensiones",
            "Análisis de brecha de citas",
            "Revisión de señales técnicas y de contenido",
            "Roadmap priorizado de 90 días",
          ],
        }),
        breadcrumbJsonLd([
          { name: "Inicio", path: "/es" },
          { name: "Auditoría GEO", path: PATH },
        ]),
        faqJsonLd([...GEO_READINESS_FAQS.es]),
      ],
    }),
  component: () => (
    <SiteShell>
      <GeoReadinessPage locale="es" />
    </SiteShell>
  ),
});
